import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['OnDemandStaffProfessionalCredentials', 'OnDemandStaffProfessionalCredentialByType']
});

const onDemandStaffProfessionalCredentialsApi = apiWithTags.injectEndpoints({
	tagTypes: ['OnDemandStaffProfessionalCredentials', 'OnDemandStaffProfessionalCredentialByType'],
	endpoints: (build) => ({
		getOnDemandStaffProfessionalCredentials: build.query({
			query: ({ caregiverId, managementCompanyId }) => ({
				url: `on-demand-staff/management-companies/${managementCompanyId}/professionals/${caregiverId}/credentials`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['OnDemandStaffProfessionalCredentials']
		}),
		getOnDemandStaffProfessionalCredentialByType: build.query({
			query: ({ caregiverId, credentialType, managementCompanyId }) => ({
				url: `on-demand-staff/management-companies/${managementCompanyId}/professionals/${caregiverId}/credentials/${credentialType}`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['OnDemandStaffProfessionalCredentialByType']
		})
	})
});

export const {
	useGetOnDemandStaffProfessionalCredentialsQuery,
	useGetOnDemandStaffProfessionalCredentialByTypeQuery
} = onDemandStaffProfessionalCredentialsApi;

export default onDemandStaffProfessionalCredentialsApi;
